import { FORM_ERROR } from "final-form";
import React from "react";
import { Form as FinalForm } from "react-final-form";
import { Col, Container, Row, Spinner } from "reactstrap";
import TextField from "../../components/Form/TextFieldV2/TextFieldV2";
import Footer from "src/components/Footer/Footer";
import * as S from "../../constants/StringConstants";
import { requestPasswordReset } from "../../store/reducers/authentication";
import "./ForgotPassword.scss";

interface ForgotPasswordValues {
  email: string;
}

const ForgotPassword: React.FC = () => {
  const onSubmit = async (values: ForgotPasswordValues) => {
    const { email } = values;

    try {
      const result = await requestPasswordReset(email);
      if (result === 1) {
        // Email sent successfully
        return;
      } else if (result === 0) {
        // User does not exist
        return {
          [FORM_ERROR]: S.FORGOT_PASSWORD_INVALID_EMAIL,
        };
      }
    } catch (error) {
      return {
        [FORM_ERROR]: S.ERROR_NETWORK_GENERAL,
      };
    }
  };

  return (
    <section className="login">
      <Container fluid>
        <Row>
          <Col md={7} className="login__logo-container" />
          <Col md={5} className="login__form-container">
            <div className="login__form-wrap">
              <div className="login__form-content">
                <h1>{S.FORGOT_PASSWORD_LABEL}</h1>

                <FinalForm
                  onSubmit={onSubmit}
                  render={({ handleSubmit, submitting, pristine, submitSucceeded, submitError }) => {
                    return (
                      <form noValidate className="login__form" onSubmit={handleSubmit}>
                        {submitSucceeded && !submitError ? (
                          <div className="is-valid">{S.FORGOT_PASSWORD_REST_EMAIL_SENT}</div>
                        ) : submitError ? (
                          <div className="not-valid">{submitError}</div>
                        ) : (
                          <p className="login__forgot-pass-description">{S.FORGOT_PASSWORD_DESCRIPTION}</p>
                        )}

                        <TextField
                          label={S.EMAIL_LABEL}
                          placeholder={S.EMAIL_PLACEHOLDER}
                          name="email"
                          type="email"
                          light={false}
                          disabled={submitSucceeded}
                        />
                        <button className="button-v2 primary" type="submit" disabled={pristine || submitting || submitSucceeded}>
                          {submitting ? <Spinner color="light" /> : S.FORGOT_PSWD}
                        </button>
                      </form>
                    );
                  }}
                />
              </div>

              <Footer />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ForgotPassword;
